import StateType from './state.type';

export default {
  loading: false,
  loadingCheckout: false,
  loadingVoucher: false,
  plans: [],
  actualPlan: {},
  checkout: {},
  methods: [],
} as StateType;
